import { extensionConstants } from '../constants';
import _ from 'lodash'

const initialState = {
    formOpen: false,
    isLoading: false,
    formInitialValue: {},
    extensionDatas: {
        data:[] 
    },
    magentoTokenDatas: {
        data:{
            magentos: {
                magentoID: "",
                magentoPermanentToken: "",
                magentoPermanentSecret: ""
            }
        }
    }
};

export function extension(state = initialState, action) {
    switch (action.type) {
       
        case extensionConstants.GET_OAUTH_INITIATE_SUCCESS:
            return {
                ...state,
                extensionDatas: action.data,
                isLoading: false,
                formOpen: true
            }
        case extensionConstants.GET_MAGENTO_TOKEN_SUCCESS:
            return {
                ...state,
                magentoTokenDatas: action.data,
                isLoading: false,
                formOpen: true
            }     
        default:
            return state
    }
}